import React from 'react';

export const NoCallDNCListFound = () => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.78137 51.2367C6.57661 44.8081 3.72455 44.0282 1.02259 37.9369C0.908676 37.6827 0.808434 37.4285 0.712749 37.1651C-0.604061 33.5093 -0.0709581 29.2251 2.10246 26.0177C5.13705 21.5394 10.6549 19.6306 15.8447 18.2996C21.039 16.964 26.5751 15.7808 30.5027 12.0789C32.3891 10.2996 33.7788 8.04424 35.5695 6.16786C37.3602 4.29148 39.7979 2.74786 42.3586 3.0344C45.6028 3.39489 47.8855 6.5607 48.7832 9.74499C49.6853 12.9247 49.6307 16.3169 50.4736 19.5151C51.836 24.6497 55.4219 28.9016 59.4498 32.3031C63.4777 35.7046 68.0159 38.436 72.1303 41.7358C77.0467 45.6781 81.7444 51.603 78.9696 58.0548C77.7986 60.7769 75.4976 62.8243 72.7819 63.9381C66.2935 66.6001 59.6822 64.7561 53.2257 63.3835C37.8181 60.1177 33.3024 65.2887 21.704 73.8041C18.0588 76.48 13.1834 77.9728 9.00063 76.2859C5.30992 74.7931 2.81755 71.0219 2.0794 67.0612C1.3367 63.1004 2.13864 58.9826 3.52835 55.2067C4.01589 53.8803 4.40774 52.5493 4.77682 51.2367H4.78137Z"
      fill="#EFF6FF"
    />
    <path
      d="M10.5844 18.0988C6.46514 19.0878 3.90328 23.2453 4.89639 27.3814C5.88544 31.5006 10.0428 34.0625 14.179 33.0693C18.3152 32.0761 20.8561 27.9062 19.8672 23.7866C18.8783 19.6671 14.7038 17.1097 10.5844 18.0988ZM11.5051 21.9336C11.9662 21.8229 12.4498 21.8516 12.8945 22.0161C13.3392 22.1806 13.7251 22.4735 14.0031 22.8576C14.2811 23.2418 14.4388 23.6998 14.4562 24.1737C14.4735 24.6475 14.3497 25.1159 14.1005 25.5193C13.8513 25.9227 13.4879 26.243 13.0564 26.4396C12.6249 26.6362 12.1447 26.7002 11.6768 26.6235C11.2089 26.5468 10.7742 26.3329 10.4281 26.0088C10.0819 25.6848 9.83975 25.2652 9.73237 24.8033C9.42679 23.5307 10.2323 22.2392 11.5051 21.9336ZM13.8091 31.5287C12.4417 31.8592 11.002 31.704 9.73642 31.0898C10.5267 29.6603 11.676 28.6936 13.0492 28.3638C14.4223 28.0341 15.8979 28.3528 17.2384 29.2884C16.3898 30.4104 15.1775 31.2023 13.8091 31.5287Z"
      fill="#CAE2FF"
    />
    <g clipPath="url(#clip0_41664_47813)">
      <path
        d="M33 27.2661C33.2689 27.266 33.5329 27.3383 33.7644 27.4752C33.9958 27.6122 34.1861 27.8088 34.3155 28.0446L34.392 28.2096L37.392 35.7096C37.5128 36.0114 37.5324 36.3442 37.4477 36.658C37.363 36.9718 37.1787 37.2496 36.9225 37.4496L36.7725 37.5516L34.2615 39.0576L34.356 39.2121C35.5511 41.1096 37.1565 42.715 39.054 43.9101L39.207 44.0031L40.7145 41.4951C40.8816 41.2162 41.1347 40.9992 41.4358 40.8766C41.7369 40.7541 42.0697 40.7327 42.384 40.8156L42.5565 40.8741L50.0565 43.8741C50.3062 43.9737 50.5246 44.1387 50.6887 44.3516C50.8529 44.5646 50.9567 44.8177 50.9895 45.0846L51 45.2661V51.2661C51 53.7516 48.9855 55.7661 46.41 55.7631C33.5415 54.9816 23.283 44.7231 22.5 31.7661C22.4999 30.6183 22.9385 29.5138 23.7259 28.6787C24.5134 27.8436 25.5902 27.341 26.736 27.2736L27 27.2661H33Z"
        fill="#BFDBFE"
      />
    </g>
    <line
      x1="47.5"
      y1="31.1803"
      x2="21.9142"
      y2="56.7661"
      stroke="#BFDBFE"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M62.1554 55.7944C59.6989 54.7511 56.8433 55.896 55.7958 58.3626C54.7525 60.8191 55.8974 63.6747 58.364 64.7222C60.8307 65.7697 63.6804 64.6106 64.7238 62.154C65.7673 59.6973 64.6121 56.8376 62.1554 55.7944ZM61.1843 58.0813C61.4592 58.198 61.6933 58.3938 61.8568 58.6439C62.0203 58.8939 62.1059 59.1868 62.1027 59.4855C62.0995 59.7842 62.0077 60.0753 61.8388 60.3217C61.67 60.5682 61.4318 60.7589 61.1544 60.8698C60.877 60.9806 60.5729 61.0066 60.2807 60.9444C59.9885 60.8822 59.7214 60.7346 59.5132 60.5204C59.305 60.3061 59.1651 60.0349 59.1113 59.7411C59.0575 59.4472 59.0921 59.144 59.2109 58.8699C59.5332 58.1109 60.4252 57.7589 61.1843 58.0813ZM58.7542 63.8035C57.9379 63.4583 57.2671 62.84 56.8565 62.0546C57.7925 61.627 58.7368 61.5683 59.5557 61.916C60.3747 62.2638 61.0024 62.9783 61.3304 63.9545C60.4802 64.2045 59.5694 64.1511 58.7542 63.8035Z"
      fill="#BFDBFE"
    />
    <path
      d="M53.6815 16.0322L45.2576 12.0056C44.7736 12.3214 44.0128 13.3975 44.8416 15.1754C45.8775 17.3977 48.1761 18.3822 50.6765 18.407C52.6768 18.4268 53.5133 16.8321 53.6815 16.0322Z"
      fill="#EFF6FF"
    />
    <circle
      cx="49.8036"
      cy="13.0697"
      r="5.34983"
      transform="rotate(-33.1232 49.8036 13.0697)"
      stroke="#9CC8FF"
      strokeWidth="1.30034"
    />
    <path
      d="M44.9628 10.1247L54.8939 15.5853"
      stroke="#9CC8FF"
      strokeWidth="1.30034"
    />
    <defs>
      <clipPath id="clip0_41664_47813">
        <rect
          width="36"
          height="36"
          fill="white"
          transform="translate(19.5 22.7661)"
        />
      </clipPath>
    </defs>
  </svg>
);
